// extracted by mini-css-extract-plugin
module.exports = {"labelTipoPessoa":"Registro_labelTipoPessoa__4hGlY"};